import React from 'react';
import { EmailSubmissionForm } from '../../../components/email-submission-form/email-submission-form';
import './landing-page.backstreetboys.container.sass';
import { PreviewHeader, PreviewHeaderType } from '../../../components/preview-header/preview-header';
import {
  RainbowDivider,
  RainbowDividerSideColors,
  RainbowDividerTheme
} from '../../../components/rainbow-divider/rainbow-divider';
import { PreviewFooter } from '../../../components/preview-footer/preview-footer';
import { LandingPageBackstreetboysDescription } from '../components/description/landing-page.backstreetboys.description';
import { LandingPageBackstreetboysForm } from '../components/form/landing-page.backstreetboys.form';

export const LandingPageBackstreetBoysContainer = () => {

  return (
    <div className='vv-landing-page-backstreetboys-container'>
      <PreviewHeader type={PreviewHeaderType.BACKS_STREET_BOYS}/>
      <LandingPageBackstreetboysDescription/>
      <RainbowDivider theme={RainbowDividerTheme.DARK} leftColor={RainbowDividerSideColors.lightGray} rightColor={RainbowDividerSideColors.black}/>
      <LandingPageBackstreetboysForm/>
      <PreviewFooter/>
    </div>
  );
};
